var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryBatteryYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0163 61.7981H7.98366C4.22996 61.7981 1.18652 58.7163 1.18652 54.9147V8.0858C1.18652 4.28374 4.22996 1.2019 7.98366 1.2019H55.0163C58.77 1.2019 61.813 4.28374 61.813 8.0858V54.9147C61.813 58.7163 58.77 61.7981 55.0163 61.7981Z",
    stroke: "#010202",
    strokeWidth: 2.385
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7836 15.4678V16.9237H24.1271C23.398 16.9237 22.8069 17.579 22.8069 18.3877V47.1887C22.8069 47.9969 23.398 48.6523 24.1271 48.6523H38.9054C39.6345 48.6523 40.2256 47.9969 40.2256 47.1887V18.3877C40.2256 17.579 39.6345 16.9237 38.9054 16.9237H35.2489V15.4678C35.2489 14.6573 34.7684 14.0001 34.1754 14.0001H28.8566C28.2641 14.0001 27.7836 14.6573 27.7836 15.4678Z",
    fill: "#0A9039"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_714_4236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 63H63V0H0V63Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_714_4236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0789 46.4742H37.9535V19.1019H25.0789V46.4742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 44.3049H36.4805V39.5848H26.5947V44.3049Z",
    fill: "#0A9039"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 39.1082H36.4805V34.3882H26.5947V39.1082Z",
    fill: "#0A9039"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5947 33.9592H36.4805V29.2391H26.5947V33.9592Z",
    fill: "#0A9039"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBatteryYes);
export default __webpack_public_path__ + "static/media/summary_battery_yes.bb6d90faa410755597cad08deb97e33c.svg";
export { ForwardRef as ReactComponent };